import React from 'react';

import { Segment } from 'semantic-ui-react';

const FilterWrapper = ({
  advancedFilters, other, date, stickyRight, stickyStyles,
}) => (
  <Segment className="filter-wrap-v3">
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {other}
        {date}
      </div>
      {stickyRight && (
      <div style={stickyStyles || { display: 'flex', alignItems: 'flex-end' }}>
        {stickyRight}
      </div>
      )}
    </div>
    {advancedFilters && (
      <div style={{ paddingTop: '10px' }}>
        {advancedFilters}
      </div>
    )}
  </Segment>
);

export default FilterWrapper;
